module.exports = __webpack_public_path__ + "img/淮北矿工总医院.e79dd61d.png";